import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { Derogation } from '@classes/derogation/derogation';

@Component({
    selector: 'app-derogation',
    templateUrl: './derogation.component.html',
    styleUrls: ['./derogation.component.scss']
})
export class DerogationComponent implements OnInit {
    derogations: Derogation[];

    constructor(
        private route: ActivatedRoute
    ) { }

    ngOnInit() {
        this.getRouteData();
    }

    private getRouteData(): void {
        this.route.data
        .subscribe((data: {derogations: Derogation[]}) => {
            this.derogations = data.derogations;
        });
    }
}
